export default __webpack_public_path__ + "75be239.svg";